"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { getAvatarColorByName } from "./AvatarColor";
import { User, IconSize, Team, Account, Add } from "../../icons";
import { Label } from "../Label";
import classNames from "classnames";
export var AvatarSize = /* @__PURE__ */function (AvatarSize2) {
  AvatarSize2["Small"] = "small";
  AvatarSize2["Large"] = "large";
  return AvatarSize2;
}(AvatarSize || {});
export var AvatarType = /* @__PURE__ */function (AvatarType2) {
  AvatarType2["User"] = "user";
  AvatarType2["Team"] = "team";
  AvatarType2["Account"] = "account";
  return AvatarType2;
}(AvatarType || {});
var Avatar = /*#__PURE__*/function (_React$Component) {
  _inherits(Avatar, _React$Component);
  var _super = _createSuper(Avatar);
  function Avatar(props) {
    var _this;
    _classCallCheck(this, Avatar);
    _this = _super.call(this, props);
    _this.getAvatarColor = function () {
      var _this$props = _this.props,
        lastName = _this$props.lastName,
        firstName = _this$props.firstName;
      return getAvatarColorByName((firstName != null ? firstName : "") + (lastName != null ? lastName : ""));
    };
    _this.renderInnerAvatar = function () {
      if (!!_this.props.firstName) {
        return _this.renderWithInitials();
      } else {
        return _this.renderAvatarIcon();
      }
    };
    _this.renderWithInitials = function () {
      var _this$props2 = _this.props,
        firstName = _this$props2.firstName,
        lastName = _this$props2.lastName,
        size = _this$props2.size,
        image = _this$props2.image;
      var avatarLabelSize = size === "large" /* Large */ ? "m" : "s";
      return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Label, {
        size: avatarLabelSize,
        "aria-label": "".concat(firstName != null ? firstName : "", " ").concat(lastName != null ? lastName : "")
      }, _this.getInitials(firstName, lastName)), !!image && /* @__PURE__ */React.createElement("img", {
        className: "avatar__image",
        alt: "",
        role: "presentation",
        src: image
      }));
    };
    _this.renderAvatarIcon = function () {
      var _this$props3 = _this.props,
        type = _this$props3.type,
        size = _this$props3.size;
      var avatarIconSize = size === "large" /* Large */ ? IconSize.Medium : IconSize.Small;
      if (type === "user" /* User */) {
        return /* @__PURE__ */React.createElement(User, {
          size: avatarIconSize
        });
      }
      if (type === "team" /* Team */) {
        return /* @__PURE__ */React.createElement(Team, {
          size: avatarIconSize
        });
      }
      if (type === "account" /* Account */) {
        return /* @__PURE__ */React.createElement(Account, {
          size: IconSize.Medium
        });
      }
    };
    var lastName = props.lastName,
      firstName = props.firstName;
    if (lastName && !firstName) {
      throw new Error("Avatar was given a last name but no first name");
    }
    return _this;
  }
  _createClass(Avatar, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        size = _this$props4.size,
        type = _this$props4.type,
        isInvite = _this$props4.isInvite,
        className = _this$props4.className;
      var AvatarColor = this.getAvatarColor();
      return /* @__PURE__ */React.createElement("div", {
        style: {
          backgroundColor: AvatarColor
        },
        className: classNames("avatar avatar--".concat(size, " avatar--").concat(type), className)
      }, this.renderInnerAvatar(), isInvite && /* @__PURE__ */React.createElement("div", {
        className: "avatar__invite"
      }, /* @__PURE__ */React.createElement(Add, null)));
    }
  }, {
    key: "getInitials",
    value: function getInitials(first, last) {
      if (last != null && last.length > 0) {
        return "".concat(first[0]).concat(last[0]).toUpperCase();
      } else {
        return first[0].toUpperCase();
      }
    }
  }]);
  return Avatar;
}(React.Component);
Avatar.defaultProps = {
  size: "small" /* Small */,
  type: "user" /* User */
};

Avatar = __decorateClass([observer], Avatar);
export { Avatar as default };